import { on } from './functions';

export default function ColourChipListing() {
    colourListing();
}

function colourListing() {

    on('.colour-listing', 'click', '.colour-chip-expand', (e, el) => {
        if (e.target.closest('.expand')) return;

        e.preventDefault();

        const colourChips = document.querySelectorAll('.colour-chip-expand');
        for (var i = 0; i < colourChips.length; i++) {
            colourChips[i].classList.remove("open");
            colourChips[i].removeAttribute("style");
        }

        const expand = el.querySelector('.expand');

        if (expand) {
            const close = el.querySelector('.colour-close');
            if (close) {
                close.addEventListener('click', e => {
                    e.preventDefault();
                    e.stopPropagation();
                    close.parentElement.parentElement.parentElement.removeAttribute("style");
                    close.parentElement.parentElement.parentElement.classList.remove('open');
                });
            }

            el.classList.toggle('open');
            el.style.marginBottom = (expand.offsetHeight + 30) + "px";

            window.addEventListener('resize', e => {
                if (el.classList.contains('open')) {
                    let expandUpdate = el.querySelector('.expand').offsetHeight;
                    el.style.marginBottom = (expandUpdate + 30) + "px";
                }
            });

            el.scrollIntoView({
                top: 0,
                behavior: "smooth"
            });
        }
    });
}